import React from "react";

export const SideSVG = ({ SVG, positions }) => {
  return (
    <>
      <div className="sm:block flex-flex_001 w-full lg:w-1/2 xl:w-2/5 px-4 max-h-screen relative hidden ">
        <div className=" max-w-xl mx-auto lg:mx-0 lg:max-w-3xl h-full">
          <div>
            <svg
              width="507"
              height="1024"
              viewBox="0 0 507 1024"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2088_26699)">
                <path d="M507 0H0V1024H507V0Z" fill="#FC7457" />
                <path
                  d="M-287.743 241.316L355.091 806.912L523.494 -32.5972L-287.743 241.316Z"
                  fill="url(#paint0_linear_2088_26699)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2088_26699"
                  x1="392.1"
                  y1="37.1295"
                  x2="50.7689"
                  y2="504.653"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFA997" />
                  <stop offset="1" stopColor="#FC8A72" stopOpacity="0" />
                </linearGradient>
                <clipPath id="clip0_2088_26699">
                  <path d="M507 0H0V1024H507V0Z" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div
            className={`absolute bg-cover bg-center ${
              positions ? positions : "bottom-0"
            }`}
          >
            <SVG />
          </div>
        </div>
      </div>
    </>
  );
};
